import type { FC } from 'react';
import styled from 'styled-components';
import { placeholderStyle } from 'src/components/form/styles';

const NullStyles = styled.span`
  ${placeholderStyle}
`;

type Props = {
  label?: string | JSX.Element;
};

export const EmptyValue: FC<Props> = ({ label = '--' }) => (
  <NullStyles>{label}</NullStyles>
);
